document.querySelectorAll('[data-coach-gifts]').forEach(root=>{
 const buttons=[...root.querySelectorAll('[data-gift-budget]')];
 const cards=[...root.querySelectorAll('[data-gift-price]')];
 const status=root.querySelector('[data-gift-count]');
 const empty=root.querySelector('[data-gift-empty]');
 root.querySelector('[data-gift-filters]').hidden=false;
 buttons.forEach(button=>button.addEventListener('click',()=>{
  const budget=button.dataset.giftBudget;
  buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  let shown=0;
  cards.forEach(card=>{const price=Number(card.dataset.giftPrice);const show=budget==='all'||(budget==='under50'&&price<5000)||(budget==='middle'&&price>=5000&&price<=10000)||(budget==='over100'&&price>10000);card.hidden=!show;if(show)shown++;});
  status.textContent=shown+' '+status.dataset.label;
  empty.hidden=shown!==0;
 }));
});
